/**
 * Catálogo Padronizado de Unidades de Medida Comerciais e Fiscais (SEFAZ / NF-e).
 */

export const PRODUCT_UNIT_CATEGORIES = {
  CONTAGEM: 'Contagem / Unidades',
  PESO: 'Peso',
  VOLUME: 'Volume / Líquidos',
  EMBALAGEM: 'Embalagens Coletivas',
  DIMENSAO: 'Dimensão / Medidas',
  OUTROS: 'Outros Formatos',
};

export const PRODUCT_UNITS = [
  // Contagem
  { code: 'UN', label: 'Unidade', category: PRODUCT_UNIT_CATEGORIES.CONTAGEM, isFractional: false, popular: true },
  { code: 'PC', label: 'Peça', category: PRODUCT_UNIT_CATEGORIES.CONTAGEM, isFractional: false, popular: true },
  { code: 'PCT', label: 'Pacote', category: PRODUCT_UNIT_CATEGORIES.CONTAGEM, isFractional: false, popular: true },
  { code: 'PAR', label: 'Par', category: PRODUCT_UNIT_CATEGORIES.CONTAGEM, isFractional: false },
  { code: 'DZ', label: 'Dúzia', category: PRODUCT_UNIT_CATEGORIES.CONTAGEM, isFractional: false },
  { code: 'KT', label: 'Kit', category: PRODUCT_UNIT_CATEGORIES.CONTAGEM, isFractional: false },
  { code: 'CENT', label: 'Cento', category: PRODUCT_UNIT_CATEGORIES.CONTAGEM, isFractional: false },
  { code: 'MIL', label: 'Milheiro', category: PRODUCT_UNIT_CATEGORIES.CONTAGEM, isFractional: false },

  // Peso
  { code: 'KG', label: 'Quilograma', category: PRODUCT_UNIT_CATEGORIES.PESO, isFractional: true, popular: true },
  { code: 'G', label: 'Grama', category: PRODUCT_UNIT_CATEGORIES.PESO, isFractional: true },
  { code: 'TON', label: 'Tonelada', category: PRODUCT_UNIT_CATEGORIES.PESO, isFractional: true },

  // Volume
  { code: 'L', label: 'Litro', category: PRODUCT_UNIT_CATEGORIES.VOLUME, isFractional: true, popular: true },
  { code: 'ML', label: 'Mililitro', category: PRODUCT_UNIT_CATEGORIES.VOLUME, isFractional: true },
  { code: 'DOSE', label: 'Dose', category: PRODUCT_UNIT_CATEGORIES.VOLUME, isFractional: false },
  { code: 'COP', label: 'Copo', category: PRODUCT_UNIT_CATEGORIES.VOLUME, isFractional: false },
  { code: 'LT', label: 'Lata', category: PRODUCT_UNIT_CATEGORIES.VOLUME, isFractional: false },
  { code: 'BD', label: 'Balde', category: PRODUCT_UNIT_CATEGORIES.VOLUME, isFractional: false },
  { code: 'GL', label: 'Galão', category: PRODUCT_UNIT_CATEGORIES.VOLUME, isFractional: true },

  // Embalagens Coletivas
  { code: 'CX', label: 'Caixa', category: PRODUCT_UNIT_CATEGORIES.EMBALAGEM, isFractional: false, popular: true },
  { code: 'FD', label: 'Fardo', category: PRODUCT_UNIT_CATEGORIES.EMBALAGEM, isFractional: false, popular: true },
  { code: 'SC', label: 'Saco', category: PRODUCT_UNIT_CATEGORIES.EMBALAGEM, isFractional: false },
  { code: 'RL', label: 'Rolo', category: PRODUCT_UNIT_CATEGORIES.EMBALAGEM, isFractional: false },
  { code: 'AMP', label: 'Ampola', category: PRODUCT_UNIT_CATEGORIES.EMBALAGEM, isFractional: false },

  // Dimensões
  { code: 'M', label: 'Metro', category: PRODUCT_UNIT_CATEGORIES.DIMENSAO, isFractional: true },
  { code: 'M2', label: 'Metro Quadrado', category: PRODUCT_UNIT_CATEGORIES.DIMENSAO, isFractional: true },
  { code: 'M3', label: 'Metro Cúbico', category: PRODUCT_UNIT_CATEGORIES.DIMENSAO, isFractional: true },
  { code: 'CM', label: 'Centímetro', category: PRODUCT_UNIT_CATEGORIES.DIMENSAO, isFractional: true },
];

/**
 * Top unidades mais frequentes para atalhos em chips de 1 clique
 */
export const POPULAR_UNIT_CODES = ['UN', 'KG', 'L', 'CX', 'FD', 'PCT'];

/**
 * Normaliza o código da unidade para maiúsculo limpo (default: 'UN')
 */
export const normalizeUnitCode = (rawCode) => {
  if (!rawCode || typeof rawCode !== 'string') return 'UN';
  const clean = rawCode.trim().toUpperCase();
  return clean || 'UN';
};

/**
 * Localiza a definição da unidade ou retorna um objeto genérico para unidades livres/customizadas
 */
export const findUnitDef = (code) => {
  const normalized = normalizeUnitCode(code);
  const found = PRODUCT_UNITS.find((u) => u.code === normalized);
  if (found) return found;
  return {
    code: normalized,
    label: normalized,
    category: PRODUCT_UNIT_CATEGORIES.OUTROS,
    isFractional: false,
    popular: false,
  };
};

/**
 * Retorna string formatada amigável para exibição: ex "KG - Quilograma" ou "UN (Unidade)"
 */
export const formatUnitDisplay = (code, full = false) => {
  const def = findUnitDef(code);
  if (!full) return def.code;
  return def.code === def.label ? def.code : `${def.code} - ${def.label}`;
};

/**
 * Verifica se a unidade é de peso ou volume fracionável (aceita casas decimais)
 */
export const isFractionalUnit = (code) => {
  const def = findUnitDef(code);
  return Boolean(def.isFractional);
};

/**
 * Retorna o step e o número de casas decimais sugeridas para inputs
 */
export const getUnitInputStep = (code) => {
  return isFractionalUnit(code) ? 'any' : '1';
};

